// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1DUlA","item":"PaymentsMobile_item__3hkpl","label":"PaymentsMobile_label__Mg7Di","amount":"PaymentsMobile_amount__3kfzj"};